import { OrderDetail } from "@omni/types/api/cart/bff/orderDetail.model";
import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import {
    CartImpressionTrackingInfo,
    CartImpressionTrackingInfoItem
} from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";
import { ModelMapper } from "@omni/types/utils/modelMapper";

const warrantyProductInfo = {
    name: "Waarborg pallet",
    analytics: {
        productTitle: "Waarborg pallet",
        superCategoryCode: "waarborg",
        superCategoryName: "Waarborg"
    }
};

const toOrderImpression: ModelMapper<
    { order: OrderDetail; name: string },
    CartImpressionTrackingInfo
> = ({ order, name }) => {
    const cartItems = (order.items || []).filter((item) => !!item.product);

    return {
        name,
        email: order.customer.email,
        totalPrice: order.totalPrice,
        promotions: order.promotions,
        globalDiscounts: order.globalDiscounts,
        deliveryCost: order.deliveryCost,
        orderId: order.orderId,
        payments: order.payments,
        items: cartItems.map(
            (
                item: OrderItem,
                index: number
            ): CartImpressionTrackingInfoItem => {
                const analytics = item.warrantyDeposit
                    ? item.product?.analytics || warrantyProductInfo.analytics
                    : item.product?.analytics;

                const { superCategoryCode = "" } = analytics || {};

                const reduction = item.strikethroughPrice
                    ? item.strikethroughPrice - item.totalPrice
                    : 0;

                return {
                    name:
                        (item.warrantyDeposit
                            ? item.product?.productTitle ||
                              item.product?.analytics.productTitle ||
                              warrantyProductInfo.name
                            : item.product?.productTitle) || "",
                    id: item.sku,
                    ean: item.product?.ean,
                    category: superCategoryCode,
                    price: item.totalPrice,
                    unitPrice: item.unitPrice,
                    tax: "21%",
                    reduction: reduction,
                    currencyCode: "EUR",
                    quantity: item.quantity,
                    url: item.product?.url,
                    placement: index + 1,
                    brand: item.product?.brandName || ""
                };
            }
        )
    };
};

export { toOrderImpression as getOrderDetailsImpressionTrackingInfo };
